module.exports = __webpack_public_path__ + "img/Logo_gray@2x.5563a6ea.png";